import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Divider from '@material-ui/core/Divider';

import styles from './styles.js';

import { iPhoneFriendlyButtonLabel } from '../../helpers/stringHelpers.js';

class BaseDialog extends React.Component {
  render() {
    const {
      classes,
      open,
      largeTitle,
      title,
      content,
      bottomContent,
      contentWrap,
      isHTML,
      centre,
      buttonAction,
      buttonLabel,
      buttonDisabled,
      buttonColour,
      buttonCustomClass,
      buttonDownloadLink,
      buttonDownloadFileName,
      secondaryButtonAction,
      secondaryButtonLabel,
      secondaryButtonCustomClass,
      supplementaryButtonAction,
      supplementaryButtonLabel,
      icon,
      iconColour,
      inlineTitle,
    } = this.props;

    const Icon = icon;

    const dialogContent = isHTML ? (
      <Typography
        component='div'
        className={`${classes.documentStyle} ${centre && classes.centre}`}
      >
        {content}
      </Typography>
    ) : (
      content
    );

    // If primary button is a download link, make the button a hyperlink
    // component instead of a button and add download attributes.
    const primaryButtonProps = {
      component: buttonDownloadLink ? 'a' : 'button',
    };
    if (buttonDownloadLink) {
      primaryButtonProps.href = buttonDownloadLink;
      primaryButtonProps.target = '_blank';
      primaryButtonProps.download = buttonDownloadFileName
        ? buttonDownloadFileName
        : true;
    }

    return (
      <div className={classes.root}>
        <Dialog open={open} classes={{ paper: classes.dialog }}>
          {largeTitle ? (
            <React.Fragment>
              <DialogTitle
                className={classes.dialogTitleLarge}
                disableTypography={true}
              >
                <div className={classes.heading}>
                  <div className={inlineTitle ? classes.headingInline : ''}>
                    <Icon
                      className={classes.iconLarge}
                      style={{ color: iconColour }}
                    />
                    <Typography variant='h3'>{title}</Typography>
                  </div>
                </div>
              </DialogTitle>
              <Divider />
              <br />
            </React.Fragment>
          ) : (
            <DialogTitle
              className={classes.dialogTitle}
              disableTypography={true}
            >
              <div>
                <Icon className={classes.icon} style={{ color: iconColour }} />
                {title && (
                  <Typography variant='h3' className={classes.title}>
                    {title}
                  </Typography>
                )}
              </div>
            </DialogTitle>
          )}

          <DialogContent className={classes.dialogContent}>
            {contentWrap ? (
              <Typography className={classes.dialogText}>
                {dialogContent}
              </Typography>
            ) : (
              dialogContent
            )}
          </DialogContent>
          <DialogActions
            className={
              secondaryButtonLabel && secondaryButtonAction
                ? classes.dialogActionsMultiple
                : classes.dialogActionsSingle
            }
          >
            {secondaryButtonLabel && secondaryButtonAction ? (
              <Button
                variant='outlined'
                onClick={secondaryButtonAction}
                className={secondaryButtonCustomClass}
              >
                {secondaryButtonLabel}
              </Button>
            ) : (
              ''
            )}
            <div className={classes.buttonGroup}>
              {supplementaryButtonLabel && supplementaryButtonAction ? (
                <Button
                  className={classes.supplementaryButton}
                  onClick={supplementaryButtonAction}
                  variant='outlined'
                  color='primary'
                  style={{ backgroundColor: buttonColour }}
                  {...primaryButtonProps}
                >
                  {supplementaryButtonLabel}
                </Button>
              ) : null}
              <Button
                onClick={buttonAction}
                variant='outlined'
                color='primary'
                style={{ backgroundColor: buttonColour }}
                className={buttonCustomClass}
                disabled={buttonDisabled}
                {...primaryButtonProps}
              >
                {iPhoneFriendlyButtonLabel(buttonLabel, buttonDisabled)}
              </Button>
            </div>
          </DialogActions>
          {bottomContent && (
            <div className={classes.bottomContent}>{bottomContent}</div>
          )}
        </Dialog>
      </div>
    );
  }
}

BaseDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool,
  largeTitle: PropTypes.bool,
  title: PropTypes.string,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.element,
  ]).isRequired,
  contentWrap: PropTypes.bool,
  isHTML: PropTypes.bool,
  centre: PropTypes.bool,
  buttonAction: PropTypes.func.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  buttonDisabled: PropTypes.bool,
  buttonColour: PropTypes.string,
  buttonCustomClass: PropTypes.string,
  buttonDownloadLink: PropTypes.string,
  buttonDownloadFileName: PropTypes.string,
  secondaryButtonAction: PropTypes.func,
  secondaryButtonLabel: PropTypes.string,
  secondaryButtonCustomClass: PropTypes.string,
  supplementaryButtonAction: PropTypes.func,
  supplementaryButtonLabel: PropTypes.string,
  supplementaryButtonCustomClass: PropTypes.string,
  icon: PropTypes.func.isRequired,
  iconColour: PropTypes.string,
  inlineTitle: PropTypes.bool,
};

BaseDialog.defaultProps = {
  open: false,
  largeTitle: false,
  title: null,
  contentWrap: true,
  isHTML: false,
  centre: false,
  buttonDisabled: false,
  buttonColour: '',
  buttonCustomClass: '',
  buttonDownloadLink: null,
  buttonDownloadFileName: null,
  iconColour: '',
  secondaryButtonAction: null,
  secondaryButtonLabel: null,
  secondaryButtonCustomClass: '',
  supplementaryButtonAction: null,
  supplementaryButtonLabel: null,
  supplementaryButtonCustomClass: '',
  inlineTitle: false,
};

export default withStyles(styles)(BaseDialog);
